import React from "react";
import {
  FooterContainer,
  FooterWrapper,
} from "./FooterElements";
import "./../../App.css";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper className="container py-5">
        <div className="row">
          <div className="col-16 mt-2 ">
            <h5 className="logo-text gray-text center-align">
              Ready to transform your business with AI? 
              
              Contact us (erxholdings@gmail.com) to learn more about our services and how we can help you harness the power of generative AI. 
              </h5>
          </div>
        </div>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
